import "./Home.module.css";
import SiteForgeNavigation from "@/reusable_sections/Header";
import UnleashYourPower from "./sections/UnleashYourPower";
import TheMissionBriefing from "./sections/TheMissionBriefing";
import ApparelForTheMission from "./sections/ApparelForTheMission";
import FeaturedMissionGear from "./sections/FeaturedMissionGear";
import CommunityRallyPoint from "./sections/CommunityRallyPoint";
import JoinTheNest from "./sections/JoinTheNest";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteForgeNavigation />
      <UnleashYourPower />
      <TheMissionBriefing />
      <ApparelForTheMission />
      <FeaturedMissionGear />
      <CommunityRallyPoint />
      <JoinTheNest />
      <Footer />
    </div>;
}